import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoyaltyCategoryType } from '@fgb/core';

@Component({
  selector: 'fgbcl-game-predictor-thanks-for-playing-modal',
  templateUrl: './game-predictor-thanks-for-playing-modal.component.html',
  styleUrl: './game-predictor-thanks-for-playing-modal.component.scss',
})
export class GamePredictorThanksForPlayingModalComponent {
  @Output() editPredictions = new EventEmitter(); // Output to notify the parent component
  onDestroy: EventEmitter<any> = new EventEmitter();
  @Input() endDate: string;

  @Input() redirectPageURL: string;
  loyaltyCategoryType = LoyaltyCategoryType.Games;

  closeModalButton(type: string) {
    this.onDestroy.emit(type);
  }

  enableEditPredictions() {
    this.editPredictions.emit();
  }
}
